// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__u1s-r","loading":"style_loading__pgQuz"};